export const palette_avery_SW900 = {
    "#ffffff" : {
        display: "Kaplama Yok",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
    "#f44336" : {
        display: "Uzaysal Turuncu 3M 3080 Pro Serisi",
        name: "Stok Kodu: AAAAAA",
        material: "01_default",
    },
}